export { default } from './CarGallery';
